import React, {Component} from 'react';
import {Tooltip} from "antd";


class InterviewNormalTitle extends Component {
    render() {
        let {record} = this.props;
            return  <div style={{width:"550px",overflow: "hidden",textOverflow: "ellipsis",whiteSpace:"nowrap"}}>
            <div title={record.title}>
             {record.title}
            </div>
        </div>
    }
}

export default InterviewNormalTitle;
